import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import type { PropType } from "@vue/runtime-core";
import { computed } from "vue";
import BaseIcon from "@/components/base/BaseIcon.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseFigureForIcon',
  props: {
  icon: {
    type: String,
    default: "arrow",
  },
  isButton: {
    type: Boolean,
    default: false,
  },
  position: {
    type: String as PropType<"left" | "right" | "bottom" | "top">,
    default: "right",
  },
  folder: {
    type: String,
    default: "ui",
  },
  color: {
    type: String as PropType<
      | "customer"
      | "white"
      | "white-opacity-15"
      | "white-opacity-40"
      | "grey-full"
      | "grey-secondary"
      | "primary"
      | "secondary"
    >,
    default: "white",
  },
  size: {
    type: String as PropType<"small" | "medium" | "large" | "extra-large">,
    default: "medium",
  },
  radius: {
    type: String,
    default: "50%",
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  isOriginalColor: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

_useCssVars(_ctx => ({
  "6f8638c0": (__props.radius)
}))

const props = __props;

const classes = computed(() => {
  return [
    `--color-${props.color}`,
    `--size-${props.size}`,
    `--${props.position}`,
    { "--disabled": props.disabled },
  ];
});

const tag = computed(() => {
  if (props.isButton) return "button";
  else return "div";
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(tag.value), {
    class: _normalizeClass(["base-figure-for-icon", classes.value])
  }, {
    default: _withCtx(() => [
      _createVNode(BaseIcon, {
        folder: __props.folder,
        name: __props.icon,
        position: __props.position,
        isOriginalColor: __props.isOriginalColor
      }, null, 8, ["folder", "name", "position", "isOriginalColor"])
    ]),
    _: 1
  }, 8, ["class"]))
}
}

})